import { render, staticRenderFns } from "./DutyTypeListAddNew.vue?vue&type=template&id=2346a142&"
import script from "./DutyTypeListAddNew.vue?vue&type=script&lang=js&"
export * from "./DutyTypeListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DutyTypeListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports